import { BASE_API_URL } from "../../../config";
import { authFetch } from "../../authHelper";

export const getCommands = {
  //
  async getCommon(apiCommand) {
    const apiPath = `${BASE_API_URL}/api/${apiCommand}`;
    const response = await authFetch(apiPath, {
      method: "GET",
    });
    const result = await response.json();
    return result;
  },
};
